import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { useTranslation } from 'react-i18next';
import SvgIcon from '@mui/material/SvgIcon';
import HavingTroubleSvg from '@app/images/svg/having-trouble.svg';

export default function LoginCallbackError({ onClick, error }) {
  const { t } = useTranslation();
  return (
    <Box
      display="flex"
      justifyContent="space-around"
      alignItems="center"
      flexDirection="column"
      height="100vh"
    >
      <Box textAlign="center" p={6}>
        <SvgIcon
          viewBox="0 0 1208 1177"
          component={HavingTroubleSvg}
          sx={{
            width: 'auto',
            height: '200px',
            margin: '0 auto',
          }}
        />
        <Typography
          variant="h4"
          sx={{
            marginBottom: '4px',
          }}
        >
          {t('login.callbackError')}
        </Typography>
        <Typography variant="h4">{t('common.pleaseTryAgain')}</Typography>
        <Typography
          sx={{
            marginTop: '24px',
            maxWidth: '400px',
            fontSize: '12px',
            lineHeight: '18px',
          }}
        >
          {t('login.errorDetails', { message: error?.error?.message })}
        </Typography>

        <Button
          variant="contained"
          color="secondary"
          disableElevation
          onClick={onClick}
          sx={{
            marginTop: '24px',
            borderRadius: '20px',
          }}
        >
          {t('common.tryAgain')}
        </Button>
      </Box>
    </Box>
  );
}
